import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersByIdPatchSlice } from './patch';
import { coreUsersByIdPostSlice } from './post';

import {
	coreUsersByIdNotificationPreferencesReducers,
	coreUsersByIdNotificationPreferencesWatchers
} from './notification-prefs';
import { coreUsersByIdPasswordReducers, coreUsersByIdPasswordWatchers } from './password';
import { coreUsersByIdPictureReducers, coreUsersByIdPictureWatchers } from './picture';
import {
	coreUsersByIdSalesforcePreferencesReducers,
	coreUsersByIdSalesforcePreferencesWatchers
} from './salesforce-prefs';

export const coreUsersByIdReducers = combineReducers({
	notificationPrefs: coreUsersByIdNotificationPreferencesReducers,
	password: coreUsersByIdPasswordReducers,
	patch: coreUsersByIdPatchSlice.asyncReducers,
	picture: coreUsersByIdPictureReducers,
	post: coreUsersByIdPostSlice.asyncReducers,
	salesforcePrefs: coreUsersByIdSalesforcePreferencesReducers
});

export const coreUsersByIdWatchers = combineAllWatchers([
	coreUsersByIdNotificationPreferencesWatchers,
	coreUsersByIdPasswordWatchers,
	coreUsersByIdPatchSlice.asyncWatchers,
	coreUsersByIdPictureWatchers,
	coreUsersByIdPostSlice.asyncWatchers,
	coreUsersByIdSalesforcePreferencesWatchers
]);
